/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logo_SubtitleInputs */

const he_logo_subtitle = /** @type {(inputs: Logo_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מעקב היסטוריית מחירים ב ksp`)
};

const en_logo_subtitle = /** @type {(inputs: Logo_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KSP Price History Tracker`)
};

/**
* | output |
* | --- |
* | "KSP Price History Tracker" |
*
* @param {Logo_SubtitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const logo_subtitle = /** @type {((inputs?: Logo_SubtitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logo_SubtitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_logo_subtitle(inputs)
	return en_logo_subtitle(inputs)
});